import { z } from 'zod';

const createTimeRegExp = /(\d+)/gi;

export const stringifiedDateSchema = z.union([z.string(), z.date(), z.number()]).transform((val) => {
  if (val instanceof Date) {
    return val.valueOf();
  }
  if (typeof val === 'number') {
    return val;
  }
  if (val.includes('Date')) {
    return new Date(Number.parseInt((val as string).match(createTimeRegExp)?.[0] ?? '0', 10)).valueOf();
  }

  const parsed = Date.parse(val);
  return Number.isNaN(parsed) ? Date.now() : parsed;
});

export const avatarUrlSchema = z
  .union([z.string().trim(), z.string().url(), z.undefined(), z.null()])
  .transform((val) => (val === null || val === undefined ? '' : val))
  .catch('');
